import { Component } from '@angular/core';

@Component({
    selector: 'app-progress-spinner',
    templateUrl: './progress-spinner.component.html',
    styleUrls: ['./progress-spinner.component.css'],
    standalone: false
})
export class ProgressSpinnerComponent {

}
